/* Rihati - behaviour. Vanilla, no framework. */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return (window.Shopify && Shopify.currency ? Shopify.currency.active + ' ' : '$ ') +
      (cents / 100).toFixed(2);
  };

  /* ============================ menu ============================ */
  function initMenu() {
    var burger = $('[data-burger]');
    var menu   = $('[data-menu]');
    if (!burger || !menu) return;

    function set(open) {
      burger.setAttribute('aria-expanded', String(open));
      menu.setAttribute('data-open', String(open));
      document.body.setAttribute('data-lock', String(open));
      if (open) { var f = menu.querySelector('a'); if (f) f.focus(); }
    }
    burger.addEventListener('click', function () {
      set(burger.getAttribute('aria-expanded') !== 'true');
    });
    menu.addEventListener('click', function (e) {
      /* a destination, the close button, or the scrim all dismiss the drawer */
      if (e.target.closest('a') || e.target.closest('[data-menu-close]')) set(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('data-open') === 'true') {
        set(false); burger.focus();
      }
    });
  }

  /* ============================ cart ============================ */
  var Cart = {
    drawer: null,

    init: function () {
      Cart.drawer = $('[data-drawer]');
      if (!Cart.drawer) return;

      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); });
      });
      $$('[data-cart-close]').forEach(function (b) {
        b.addEventListener('click', Cart.close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') Cart.close();
      });

      /* add to cart, delegated so it survives section re-render in the editor */
      document.addEventListener('submit', function (e) {
        var form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        e.preventDefault();
        Cart.add(form);
      });

      /* remove line */
      Cart.drawer.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-line-remove]');
        if (!rm) return;
        e.preventDefault();
        Cart.change(rm.getAttribute('data-line-remove'), 0);
      });

      Cart.refresh();
    },

    open: function () {
      Cart.drawer.setAttribute('data-open', 'true');
      document.body.setAttribute('data-lock', 'true');
      var c = $('[data-cart-close]', Cart.drawer); if (c) c.focus();
    },

    close: function () {
      if (!Cart.drawer) return;
      Cart.drawer.setAttribute('data-open', 'false');
      document.body.setAttribute('data-lock', 'false');
    },

    add: function (form) {
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.querySelector('[data-btn-label]') : null;
      var original = label ? label.textContent : '';
      if (btn) { btn.disabled = true; }
      if (label) { label.textContent = 'Adding'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Cart.serialize(form))
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart');
          return Cart.refresh();
        })
        .then(function () { Cart.open(); })
        .catch(function (err) {
          var slot = form.querySelector('[data-form-error]');
          if (slot) { slot.textContent = err.message; slot.hidden = false; }
        })
        .then(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = original;
        });
    },

    serialize: function (form) {
      var fd = new FormData(form);
      var out = { quantity: 1, properties: {} };
      fd.forEach(function (v, k) {
        if (k === 'id') out.id = v;
        else if (k === 'quantity') out.quantity = parseInt(v, 10) || 1;
        else if (k.indexOf('properties[') === 0) {
          out.properties[k.slice(11, -1)] = v;
        }
      });
      return out;
    },

    change: function (key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(Cart.refresh);
    },

    refresh: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(Cart.render);
    },

    render: function (cart) {
      var count = $('[data-cart-count]');
      if (count) {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      }

      var body = $('[data-cart-lines]');
      var foot = $('[data-cart-foot]');
      if (!body) return cart;

      if (!cart.items.length) {
        body.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>';
        if (foot) foot.hidden = true;
        return cart;
      }

      body.innerHTML = cart.items.map(function (i) {
        var img = i.image
          ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
            '" alt="" width="72" height="72" loading="lazy">'
          : '<span></span>';
        return '<article class="line">' + img +
          '<div><a class="line__t" href="' + i.url + '">' + i.product_title + '</a>' +
          '<p class="line__m">' + i.quantity + ' x ' + money(i.final_price) + '</p>' +
          '<button class="line__rm" type="button" data-line-remove="' + i.key + '">Remove</button>' +
          '</div></article>';
      }).join('');

      if (foot) {
        foot.hidden = false;
        /* a session discount is invisible in cart totals, so say it is there */
        var note = $('[data-cart-promo]', foot);
        var noteCode = $('[data-cart-promo-code]', foot);
        var applied = null;
        try { applied = localStorage.getItem('rihati_promo_code'); } catch (e) {}
        if (note && noteCode && applied) {
          noteCode.textContent = applied;
          note.hidden = false;
        }
        var tot = $('[data-cart-total]', foot);
        if (tot) tot.textContent = money(cart.total_price);
      }
      return cart;
    }
  };

  /* ============================ motion ============================ */
  function initMotion() {
    if (!window.gsap || !window.ScrollTrigger) return;
    if (document.documentElement.getAttribute('data-motion') === 'off') return;

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power3.out', duration: 0.9 });
    document.documentElement.classList.add('reveal-ready');

    var mm = gsap.matchMedia();

    /* reduced motion: show everything, animate nothing */
    mm.add('(prefers-reduced-motion: reduce)', function () {
      gsap.set('.reveal', { opacity: 1, y: 0 });
    });

    mm.add('(prefers-reduced-motion: no-preference)', function () {
      /* staggered reveals, batched so a grid enters as one gesture */
      ScrollTrigger.batch('.reveal', {
        start: 'top 88%',
        once: true,
        onEnter: function (batch) {
          gsap.to(batch, { opacity: 1, y: 0, stagger: 0.07, overwrite: true });
        }
      });

      /* header hairline appears once the hero is behind us */
      var hdr = document.querySelector('.hdr');
      if (hdr) {
        ScrollTrigger.create({
          start: 'top -80',
          end: 99999,
          onToggle: function (self) {
            hdr.setAttribute('data-stuck', String(self.isActive));
          }
        });
      }

      /* hero parallax. Desktop only, mobile keeps the video still for battery */
      mm.add('(min-width: 768px)', function () {
        var media = document.querySelector('.hero__media');
        if (!media) return;
        gsap.to(media, {
          yPercent: 14,
          ease: 'none',
          scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true }
        });
      });

      /* word-by-word rise on the hero headline */
      var title = document.querySelector('[data-split]');
      if (title) {
        var words = title.textContent.trim().split(/\s+/);
        title.innerHTML = words.map(function (w) {
          return '<span class="w"><span>' + w + '</span></span>';
        }).join(' ');
        gsap.set(title.querySelectorAll('.w'), { display: 'inline-block', overflow: 'hidden', verticalAlign: 'bottom' });
        gsap.from(title.querySelectorAll('.w > span'), {
          yPercent: 108, duration: 1.1, stagger: 0.055, delay: 0.15,
          display: 'inline-block'
        });
      }
    });

    /* images and fonts settle after first paint, so positions must be recalculated */
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  function boot() { initMenu(); Cart.init(); initMotion(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Shopify theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', function () {
    initMenu(); Cart.init();
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  });
})();

/* ============================ the index ============================ */
(function () {
  'use strict';

  function initIndex() {
    var root = document.querySelector('[data-index]');
    if (!root) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-idx-row]'));
    if (!rows.length) return;

    /* --- tap to open. Mobile reward, and the keyboard path on every size. --- */
    rows.forEach(function (row) {
      var btn = row.querySelector('[data-idx-toggle]');
      var panel = row.querySelector('.idx__panel');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';

        rows.forEach(function (other) {
          if (other === row) return;
          var ob = other.querySelector('[data-idx-toggle]');
          var op = other.querySelector('.idx__panel');
          if (ob && ob.getAttribute('aria-expanded') === 'true') {
            ob.setAttribute('aria-expanded', 'false');
            if (window.gsap) {
              gsap.to(op, { height: 0, duration: 0.4, ease: 'power3.inOut',
                onComplete: function () { op.hidden = true; op.style.height = ''; } });
            } else { op.hidden = true; }
          }
        });

        btn.setAttribute('aria-expanded', String(!open));

        if (!window.gsap) { panel.hidden = open; return; }

        if (open) {
          gsap.to(panel, { height: 0, duration: 0.4, ease: 'power3.inOut',
            onComplete: function () { panel.hidden = true; panel.style.height = ''; } });
        } else {
          panel.hidden = false;
          gsap.fromTo(panel, { height: 0 },
            { height: 'auto', duration: 0.6, ease: 'power3.out',
              onComplete: function () { panel.style.height = ''; } });
        }
      });
    });

    /* --- cursor-follow bottle. Fine pointers on wide screens only. --- */
    if (!window.gsap) return;
    var mm = gsap.matchMedia();

    mm.add('(hover: hover) and (min-width: 1000px) and (prefers-reduced-motion: no-preference)',
    function () {
      var setters = rows.map(function (row) {
        var ghost = row.querySelector('.idx__ghost');
        if (!ghost) return null;
        gsap.set(ghost, { xPercent: -50, yPercent: -50, scale: 0.86 });
        return {
          row: row,
          ghost: ghost,
          x: gsap.quickTo(ghost, 'x', { duration: 0.55, ease: 'power3' }),
          y: gsap.quickTo(ghost, 'y', { duration: 0.65, ease: 'power3' })
        };
      }).filter(Boolean);

      function enter(s) {
        root.setAttribute('data-hot', 'true');
        s.row.setAttribute('data-hot', 'true');
        gsap.to(s.ghost, { opacity: 1, scale: 1, duration: 0.5, ease: 'power3.out', overwrite: true });
      }
      function leave(s) {
        s.row.removeAttribute('data-hot');
        gsap.to(s.ghost, { opacity: 0, scale: 0.86, duration: 0.35, ease: 'power2.in', overwrite: true });
      }

      setters.forEach(function (s) {
        s.row.addEventListener('pointerenter', function () { enter(s); });
        s.row.addEventListener('pointerleave', function () { leave(s); });
        s.row.addEventListener('pointermove', function (e) {
          s.x(e.clientX + 150);
          s.y(e.clientY);
        });
      });

      root.addEventListener('pointerleave', function () {
        root.removeAttribute('data-hot');
      });

      return function () {
        root.removeAttribute('data-hot');
        setters.forEach(function (s) {
          s.row.removeAttribute('data-hot');
          gsap.set(s.ghost, { clearProps: 'all' });
        });
      };
    });
  }

  function boot() { initIndex(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

/* ==================== product gallery ==================== */
(function () {
  'use strict';

  function initGallery() {
    var gal = document.querySelector('[data-gallery]');
    if (!gal) return;
    var track = gal.querySelector('[data-gal-track]');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-gal-slide]'));
    var dots = Array.prototype.slice.call(gal.querySelectorAll('[data-gal-dot]'));
    if (!track || slides.length < 2 || !dots.length) return;

    function select(i) {
      dots.forEach(function (d, n) { d.setAttribute('aria-selected', String(n === i)); });
    }

    /* a dot pages to its slide */
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-gal-dot'), 10) || 0;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft,
                         behavior: reduce ? 'auto' : 'smooth' });
        select(i);
      });
    });

    /* swiping updates the dots. IntersectionObserver rather than a scroll
       listener, so this costs nothing while the user is dragging. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            select(slides.indexOf(e.target));
          }
        });
      }, { root: track, threshold: [0.61] });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  function boot() { initGallery(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

/* ==================== promo popup ==================== */
(function () {
  'use strict';

  var KEY = 'rihati_promo_seen';

  function initPromo() {
    var promo = document.querySelector('[data-promo]');
    if (!promo) return;

    var box = promo.querySelector('[data-promo-box]');
    var ask = promo.querySelector('[data-promo-step="ask"]');
    var done = promo.querySelector('[data-promo-step="done"]');
    var form = promo.querySelector('form');
    var err = promo.querySelector('[data-promo-err]');
    var days = parseInt(promo.getAttribute('data-days') || '30', 10);
    var delay = parseInt(promo.getAttribute('data-delay') || '3', 10) * 1000;
    var lastFocus = null;

    /* already seen recently, or already signed up */
    try {
      var seen = parseInt(localStorage.getItem(KEY) || '0', 10);
      if (seen && Date.now() - seen < days * 864e5) return;
    } catch (e) { /* private mode: just show it */ }

    function remember() {
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }

    function open() {
      lastFocus = document.activeElement;
      promo.hidden = false;
      requestAnimationFrame(function () { promo.setAttribute('data-open', 'true'); });
      document.body.setAttribute('data-lock', 'true');
      var f = promo.querySelector('input, button');
      if (f) f.focus();
    }

    function close() {
      promo.setAttribute('data-open', 'false');
      document.body.setAttribute('data-lock', 'false');
      remember();
      setTimeout(function () { promo.hidden = true; }, 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    promo.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && promo.hidden === false) close();
    });

    /* keep tabbing inside the dialog while it is open */
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = box.querySelectorAll('a[href], button:not([disabled]), input');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* submit to Shopify's customer list, then reveal the code.
       A failed newsletter signup must not withhold the discount. */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]');
        var label = form.querySelector('[data-promo-submit]');
        if (!email || !email.checkValidity()) {
          if (email) email.setAttribute('aria-invalid', 'true');
          if (err) { err.textContent = 'Enter a valid email address.'; err.hidden = false; }
          return;
        }
        email.removeAttribute('aria-invalid');
        if (err) err.hidden = true;
        var original = label ? label.textContent : '';
        if (label) label.textContent = 'Sending';

        var reveal = function () {
          remember();
          ask.hidden = true;
          done.hidden = false;
          var a = done.querySelector('a, button');
          if (a) a.focus();
        };

        fetch(form.action, { method: 'POST', body: new FormData(form) })
          .then(reveal)
          .catch(reveal)
          .then(function () { if (label) label.textContent = original; });
      });
    }

    /* Apply the discount without showing a discount page.
       Fetching /discount/CODE is enough for Shopify to attach it to the
       session; an invisible iframe covers browsers that refuse the redirect.
       Either way we head home, and we never wait forever on the network. */
    var applyBtn = promo.querySelector('[data-promo-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var codeVal = applyBtn.getAttribute('data-code') || '';
        var home = applyBtn.getAttribute('data-home') || '/';
        var url = '/discount/' + encodeURIComponent(codeVal);
        var label = applyBtn.querySelector('span');
        if (label) label.textContent = 'Applying';

        var went = false;
        var go = function () {
          if (went) return;
          went = true;
          remember();
          try { localStorage.setItem('rihati_promo_code', codeVal); } catch (e) {}
          window.location.href = home;
        };

        var viaFrame = function () {
          var f = document.createElement('iframe');
          f.setAttribute('aria-hidden', 'true');
          f.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
          f.addEventListener('load', go);
          f.src = url;
          document.body.appendChild(f);
        };

        fetch(url, { credentials: 'same-origin', redirect: 'follow' })
          .then(go)
          .catch(viaFrame);

        /* never strand the shopper on a spinner */
        setTimeout(go, 2500);
      });
    }

    /* copy the code */
    var copy = promo.querySelector('[data-promo-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var text = copy.querySelector('.promo__codetext').textContent.trim();
        var mark = copy.querySelector('[data-promo-copylabel]');
        var ok = function () {
          if (!mark) return;
          mark.textContent = 'Copied';
          setTimeout(function () { mark.textContent = 'Copy'; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(ok).catch(function () {});
        }
      });
    }

    setTimeout(open, delay);
  }

  function boot() { initPromo(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();

/* ==================== featured product ==================== */
(function () {
  'use strict';

  function initFeat() {
    var feat = document.querySelector('[data-feat]');
    if (!feat) return;

    var rail = feat.querySelector('[data-feat-rail]');
    var dots = feat.querySelector('[data-feat-dots]');
    var slides = rail ? [].slice.call(rail.querySelectorAll('.feat__slide')) : [];

    /* Arm the lead slide's entrance only now that JS is running, then reveal
       on view. The timer guarantees the text appears even if the observer
       never fires, which is the difference between a missed animation and
       permanently invisible content. */
    feat.classList.add('feat--armed');
    var revealed = false;
    var show = function () {
      if (revealed) return;
      revealed = true;
      feat.classList.add('feat--in');
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { show(); io.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(feat);
    }
    setTimeout(show, 2500);

    /* ---- position indicator ----
       Built from the real slides, so the dot count can never disagree with
       the rail. One dot per slide; tapping one scrolls to it. */
    if (!rail || !dots || slides.length < 2) return;

    var DOT_MAX = 8;                       /* beyond this, dots wrap and stop reading */
    var useDots = slides.length <= DOT_MAX;
    var marks = [], fill, count;

    if (useDots) {
      slides.forEach(function (slide, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'feat__dot';
        b.setAttribute('aria-label', 'Go to item ' + (n + 1) + ' of ' + slides.length);
        b.setAttribute('aria-current', n === 0 ? 'true' : 'false');
        b.addEventListener('click', function () {
          rail.scrollTo({ left: slide.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      marks = [].slice.call(dots.children);
    } else {
      dots.className = 'feat__dots feat__prog';
      var track = document.createElement('span');
      track.className = 'feat__track';
      fill = document.createElement('span');
      fill.className = 'feat__fill';
      track.appendChild(fill);
      count = document.createElement('span');
      count.className = 'feat__count';
      count.setAttribute('aria-live', 'polite');
      dots.appendChild(track);
      dots.appendChild(count);
    }
    dots.hidden = false;

    var active = -1;
    function sync() {
      /* whichever slide's centre sits closest to the rail's centre */
      var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, gap = Infinity;
      slides.forEach(function (s, n) {
        var d = Math.abs((s.offsetLeft - rail.offsetLeft) + s.offsetWidth / 2 - mid);
        if (d < gap) { gap = d; best = n; }
      });
      if (best === active) return;

      if (useDots) {
        if (active > -1) marks[active].setAttribute('aria-current', 'false');
        marks[best].setAttribute('aria-current', 'true');
      } else {
        var w = 100 / slides.length;
        fill.style.width = w + '%';
        fill.style.left = (w * best) + '%';
        count.textContent = (best + 1) + ' / ' + slides.length;
      }
      active = best;
    }

    var tick;
    rail.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () { tick = 0; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }


  /* ---- show more ------------------------------------------------------
     The button is a real link to the next page, so this is pure
     enhancement: fetch that page, lift its cards out and append them.
     Falls back to plain navigation if the request fails.               */
  function initMore() {
    var btn = document.querySelector('[data-more]');
    if (!btn) return;

    var box   = btn.closest('.more');
    var grid  = document.querySelector('.grid');
    var label = btn.querySelector('[data-more-label]');
    var count = box && box.querySelector('[data-more-count]');
    if (!grid) return;

    if (count) count.setAttribute('aria-live', 'polite');

    btn.addEventListener('click', function (e) {
      var next = btn.getAttribute('data-next');
      if (!next || box.classList.contains('is-loading')) return;

      e.preventDefault();
      box.classList.add('is-loading');
      if (label) label.textContent = 'Loading';

      fetch(next, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc   = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('.grid > *');
          if (!cards.length) throw new Error('empty');

          var first = null;
          Array.prototype.forEach.call(cards, function (card) {
            var node = document.importNode(card, true);
            /* ScrollTrigger.batch collected .reveal elements at boot, so it
               will never see these. Drop the class — which is what holds
               them at opacity 0 — and let .is-new animate them in instead. */
            node.classList.remove('reveal');
            node.classList.add('is-new');
            /* the first page loads its lead image eagerly; appended ones
               are below the fold by definition, so never do that again */
            var img = node.querySelector('img[fetchpriority="high"]');
            if (img) {
              img.removeAttribute('fetchpriority');
              img.setAttribute('loading', 'lazy');
            }
            grid.appendChild(node);
            if (!first) first = node;
          });

          /* walk the button forward to whatever that page pointed at */
          var nextBtn = doc.querySelector('[data-more]');
          var nextUrl = nextBtn && nextBtn.getAttribute('data-next');
          if (nextUrl) {
            btn.setAttribute('data-next', nextUrl);
            btn.setAttribute('href', nextUrl);
          } else {
            box.hidden = true;
          }

          var nextCount = doc.querySelector('[data-more-count]');
          if (count) {
            count.textContent = nextCount
              ? nextCount.textContent.trim()
              : grid.children.length + ' of ' + grid.children.length;
          }

          /* keyboard users land on the first new card, not back at the top */
          if (first) {
            /* the card's root element is itself the link */
            var a = first.matches('a[href]') ? first : first.querySelector('a[href]');
            if (a) { a.setAttribute('tabindex', '-1'); a.focus({ preventScroll: true }); }
          }

          if (window.ScrollTrigger) ScrollTrigger.refresh();
        })
        .catch(function () {
          /* let the browser do what the link always said it would */
          window.location.href = next;
        })
        .then(function () {
          box.classList.remove('is-loading');
          if (label) label.textContent = 'Show more';
        });
    });
  }

  /* Fade the right edge of the filter strip only while there is more to
     reach, so the swipe cue never lies. */
  function initFilt() {
    var nav = document.querySelector('.filt');
    if (!nav) return;
    function sync() {
      var over = nav.scrollWidth - nav.clientWidth > 2;
      nav.classList.toggle('is-over', over);
      nav.classList.toggle('is-start', !over || nav.scrollLeft <= 2);
      nav.classList.toggle('is-end',
        !over || nav.scrollLeft >= nav.scrollWidth - nav.clientWidth - 2);
    }
    sync();
    nav.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* open on the active category when it starts out of view */
    var on = nav.querySelector('.filt__pill.is-on');
    if (on && on.offsetLeft + on.offsetWidth > nav.clientWidth) {
      nav.scrollLeft = on.offsetLeft - 16;
    }
  }

  function boot() { initFeat(); initMore(); initFilt(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
